import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListUser = (params) => sendGet("/users", params);
export const createUser = (params) => sendPost("/users", params);

export const updateUser = (id, params) =>
  sendPut(`/users/${id}`, params);

export const deleteUser = (id) => sendDelete(`/users/${id}`);
